window.appInProduction = process.env.MIX_APP_ENV === 'production';
